<script setup>
  import { computed } from 'vue';
  import ProForecastHeader from '@/components/ProForecastHeader.vue';
  import ProForecastBodyExtended from '@/components/ProForecastBodyExtended.vue';

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    requestedForecastType: {
      type: String,
      required: true
    },
    forecaster: {
      type: Object,
      default: null
    }
  });

</script>

<template>
  <ProForecastHeader :proForecast="props.proForecast" :forecaster="props.forecaster" :extended="true" :requestedForecastType="props.requestedForecastType"  />
  <ProForecastBodyExtended :proForecast="props.proForecast" />
</template>